import './App.css';
import { Auth0Provider } from '@auth0/auth0-react';
import PriceCalculator from './PriceCalculator';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import StatsTable from './StatsTable';
import ViewQuote from './ViewQuote';
import { Fragment } from 'react';

function App() {

  return (
    <Fragment>
      <BrowserRouter>
        <Routes>
          <Route
            path={'/view/:sales/:id'}
            element={<ViewQuote />} />
        </Routes>
      </BrowserRouter>
      <Auth0Provider
        domain="dev-ocxwznjx.eu.auth0.com"
        clientId="iwr3nXIAPYsvVPBZHChlteTLElL8kSH5"
        redirectUri={window.location.origin}
        scope="openid profile user_metadata read:app_metadata read:current_user_metadata read:current_user update:current_user_metadata">
        <BrowserRouter>
          <Routes>
            <Route path={'/'} element={<PriceCalculator />} />
            <Route path={'/stats'} element={<StatsTable />} />
          </Routes>
        </BrowserRouter>
      </Auth0Provider>
    </Fragment>
  )

}

export default App;
